import { PopoverInteractionKind, Switch } from "@blueprintjs/core";
import { Popover2 } from "@blueprintjs/popover2";
import { observer } from "mobx-react";
import React, { useContext } from "react";
import { StoresContext } from "../../../../pages/_app";

export const UnsequencedProductsSwitch = observer(() => {
  const rootStore = useContext(StoresContext);
  const { showUnsequencedInTree, setShowUnsequencedInTree } = rootStore.genomeStore;

  function handleChange(event: React.KeyboardEvent<HTMLInputElement>) {
    setShowUnsequencedInTree(event.currentTarget.checked);
  }

  return (
    <Popover2
      interactionKind={PopoverInteractionKind.HOVER}
      placement={"top"}
      hoverOpenDelay={350}
      content={
        <>
          We are working to sequence and generate high quality assemblies for as many microbial
          products as possible. Toggle this to include products that have not been sequenced yet.
        </>
      }
      popoverClassName="info-tooltip info-tooltip--small"
    >
      <Switch
        large={true}
        checked={showUnsequencedInTree}
        onChange={handleChange}
        className="genomes-table-toggle"
        labelElement={"Include unsequenced products"}
      />
    </Popover2>
  );
});
